import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: 'var(--color-bg-secondary)',
        borderTop: '1px solid var(--color-borders)',
      }}
    >
      <div className="container">
        <div
          className="flex items-center justify-between flex-wrap"
          style={{
            gap: 'var(--spacing-lg)',
            paddingTop: 'var(--spacing-2xl)',
            paddingBottom: 'var(--spacing-2xl)',
          }}
        >
          <div className="flex items-center gap-md">
            <span
              style={{
                fontWeight: 700,
                fontSize: 'var(--text-xl)',
                letterSpacing: '-0.02em',
                color: 'var(--color-text-primary)',
              }}
            >
              z37
            </span>
            <span
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--color-text-tertiary)',
              }}
            >
              © {year} Z37
            </span>
          </div>

          <nav
            aria-label="Footer"
            className="flex items-center flex-wrap"
            style={{ gap: 'var(--spacing-lg)', fontSize: 'var(--text-sm)' }}
          >
            <a
              href="mailto:hello@z37.io"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              hello@z37.io
            </a>
            <Link to="/privacy" style={{ color: 'var(--color-text-secondary)' }}>
              Privacy
            </Link>
            <Link to="/terms" style={{ color: 'var(--color-text-secondary)' }}>
              Terms
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
